<template>
	<div id="subscription_stop">
	</div>
</template>

<script>
	export default {
		components: {
		},
		props: {
		},
		data() {
			return {
			}
		},
		computed: {
		},
		methods: {
		},
		mounted() {
			this.$store.commit('commonStore/setRejectionUnqDone', true);
			this.$router.push('/subscription');
		}
	};
</script>

<style lang="scss" scoped>
</style>
